// extracted by mini-css-extract-plugin
module.exports = {"cohorts":"CohortsAdmin_cohorts__1nJH7","buttonContainer":"CohortsAdmin_buttonContainer__1B8Eu","button_return":"CohortsAdmin_button_return__2Q4pV"};